import { Box } from '@mui/material';
import React, { FunctionComponent, useEffect, useState } from 'react';
import UploadedResourceService from '../../../../shared/services/uploaded-resource/uploaded-resource.service';
import { getFileTypeIcon } from '../../../../shared/utils/file-type-icons';

export const UploadedResourcePreview: FunctionComponent<{
  resource: any,
  width: number,
  height: number,
}> = ({ resource, width, height }) => {
  const [thumbnailUrl, setThumbnailUrl] = useState<string | null>(null);

  useEffect(() => {
    let objectUrl: string | null = null;
    let cancelled = false;

    const loadThumbnail = async () => {
      try {
        if (resource.mimetype && resource.mimetype.startsWith('image/') && resource.id) {
          const service = new UploadedResourceService();
          const blob = await service.getDownloadBlob(resource.id);
          if (cancelled) {
            return;
          }
          objectUrl = URL.createObjectURL(blob);
          setThumbnailUrl(objectUrl);
        }
      } catch (err) {
        console.log(err);
        setThumbnailUrl(null);
      }
    };

    loadThumbnail();

    return () => {
      cancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [resource.id, resource.mimetype]);

  if (thumbnailUrl) {
    return (
      <Box
        sx={{
          width: `${width}px`,
          height: `${height}px`,
          borderRadius: '6px',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'grey.50',
        }}
      >
        <Box
          component='img'
          src={thumbnailUrl}
          alt={resource.filename}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
          }}
        />
      </Box>
    );
  }

  return getFileTypeIcon(
    { name: resource.filename, type: resource.mimetype } as File,
    Math.min(width, height) * 0.4
  );
};


